import { privateApi } from 'services';
import { JobCampaignFieldConfig } from './types';

const fetchJobCampaignFieldConfigs = async (jobGroupId: string): Promise<JobCampaignFieldConfig[]> =>
    privateApi.get<JobCampaignFieldConfig[]>(`job-group-importer-settings/${jobGroupId}/field-configs`);

export const JobCampaignFieldConfigGateway = {
    fetchJobCampaignFieldConfigs,
};
